export default __webpack_public_path__ + "static/media/smileFour.bac099b0.svg";